
<template>
  <Card>
    <template slot="title">
      <Breadcrumb>
        <BreadcrumbItem to="/orderList">采购单管理</BreadcrumbItem>
        <BreadcrumbItem>入库单</BreadcrumbItem>
      </Breadcrumb>
    </template>
    <template slot="extra">
      <!-- 状态 : 1:待审核 10：审核不通过 20: 审核通过 -->
      <Button
        v-if="showStatus == 1 && detail.status == 1"
        type="primary"
        icon="md-checkmark"
        @click="action(1)"
        >审核通过</Button
      >
      <Button
        v-if="showStatus == 1 && detail.status == 1"
        type="primary"
        icon="md-close"
        @click="action(2)"
        >审核不通过</Button
      >
      <Button
        type="primary"
        icon="ios-create"
        @click="action(3)"
        v-if="showStatus != 1 && detail.status == 1"
        >修改</Button
      >
      <Button type="primary" icon="ios-undo" @click="action(4)">返回</Button>
    </template>
    <table>
      <tr>
        <th colspan="9">入库单基础信息</th>
      </tr>
      <tr>
        <th>采购单号</th>
        <td>{{ detail.orderId }}</td>
        <th>品牌商单号</th>
        <td>{{ detail.spOrderId }}</td>
        <th>采购日期</th>
        <td>{{ detail.purchaseTime }}</td>
        <th>状态</th>
        <td>
          {{
            detail.status == 20
              ? "审核通过"
              : detail.status == 10
              ? "审核不通过"
              : "待审核"
          }}
        </td>
      </tr>
      <tr>
        <th>服务商</th>
        <td>{{ detail.spName }}</td>
        <th>仓库</th>
        <td>{{ detail.wmsName }}</td>
        <th>制单人</th>
        <td>{{ detail.createOperatorName }}</td>
        <th>审核人</th>
        <td>{{ detail.examineOperatorName }}</td>
      </tr>
      <tr>
        <th>品牌商单号</th>
        <td>{{ detail.spOrderId }}</td>
        <th>备注</th>
        <td colspan="7">{{ detail.remark }}</td>
      </tr>
    </table>
    <table>
      <tr>
        <th colspan="7">入库单商品信息</th>
      </tr>
      <tr>
        <th>封面</th>
        <th>类型</th>
        <th>品牌</th>
        <th>达能商品编号</th>
        <th>商品名称</th>
        <th>购买数量</th>
        <th>生产日期</th>
      </tr>
      <template v-if="detail.skuList">
        <tr v-for="(item, index) in detail.skuList" :key="index">
          <td>
            <Avatar shape="square" :src="item.coverImgUrl" size="large" />
          </td>
          <td>{{ item.categoryName }}</td>
          <td>{{ item.brandName }}</td>
          <td>{{ item.erpCode }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.count }}</td>
          <td>{{ item.produceDate }}</td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="7">暂无数据</td>
        </tr>
      </template>
    </table>
    <table>
      <tr>
        <th>采购单号</th>
        <th>仓库</th>
        <th>省份</th>
        <th>Grade Group</th>
        <th>商品信息</th>
        <th>拆分数量</th>
        <th>拆分模式</th>
        <th>备注</th>
      </tr>
      <template v-if="detail.splitList">
        <tr v-for="(item, index) in detail.splitList" :key="index">
          <td>{{ item.orderId }}</td>
          <td>{{ item.wmsName }}</td>
          <td>{{ item.areaName }}</td>
          <td>{{ item.gradeGroup }}</td>
          <td>{{ item.weightCount }}</td>
          <td>{{ item.splitTotalCount }}</td>
          <td>{{ item.splitModel }}</td>
          <td>{{ item.remark }}</td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="8">暂无数据</td>
        </tr>
      </template>
    </table>
  </Card>
</template>
<script>
export default {
  data() {
    return {
      orderId: "",
      showStatus: this.$route.query.showStatus,
      detail: {},
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      let q = this.$route.query;
      if (q.orderId) {
        this.orderId = q.orderId;
        this.$api["purchDetail"](q).then((res) => {
          if (res.code == "200") {
            this.detail = res.data;
          }
        });
      }
    },
    action(t) {
      switch (t) {
        case 1:
          this.examine(20);
          break;
        case 2:
          this.examine(10);
          break;
        case 3:
          this.$router.replace({
            path: "/orderAdd",
            query: { orderId: this.orderId },
          });
          break;
        default:
          this.$router.replace({ path: "/orderList" });
      }
    },
    examine(v) {
      let data = {
        orderId: this.orderId,
        status: v,
      };
      this.$api.purchExamine(data).then((res) => {
        if (res.code == "200") {
          this.$Message.success("操作成功");
          this.getDetail();
        }
      });
    },
  },
};
</script>
<style scoped>
table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
}
th,
td {
  padding: 5px 10px;
  text-align: center;
  border: 1px solid #dcdee2;
  line-height: 30px;
  color: #515a6e;
  font-size: 12px;
}
th {
  background: #f8f8f9;
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/orderDetail.vue